import { Image } from 'antd'
import './main.css'
import { useRecoilState } from 'recoil'
import { LayoutView } from '../../../../state/atom'

const GallerySerch = (props: any) => {
  const [LayoutViewNumber, setLayoutView] = useRecoilState(LayoutView);

  return (
    <div className={'gridItem'}>
      <Image.PreviewGroup>
        {props.Immagini.map((e: any) => {
          return (
            <div className={LayoutViewNumber} key={e.src}>
              <Image
                style={{ height: 300, width: 'auto' }}
                prefix='Test'
                preview={{
                  mask: (
                    <div className='ant-image-mask-info'>
                      <span role='img' aria-label='eye' className='anticon anticon-eye'></span>
                      {e.item.info}
                    </div>
                  ),
                }}
                alt={e.item.info}
                src={e.item.src}
              />
            </div>
          )
        })}
      </Image.PreviewGroup>
    </div>
  )
}

export default GallerySerch
